/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import Table from 'components/Table'
import TextInput from 'components/Form/components/TextInput'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Button from 'components/Button'
import Dialog from 'components/Dialog'

const styles = Object.assign(
  {},
  require('../PartnerPlanList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class PartnerPlanReminderNotificationList extends Component {
  static propTypes = {
    filterRemindersList: PropTypes.func.isRequired,
    header: PropTypes.string,
    partnerPlanRatingsReminderItems: PropTypes.instanceOf(Array),
    partnerPlanRatingsUpload: PropTypes.object.isRequired,
    removeEmployee: PropTypes.func.isRequired,
  }
  static defaultProps = {
    partnerPlanRatingsReminderItems: {},
    header: '',
  }
  constructor(props) {
    super(props)
    this.state = {
      search: '',
      typing: false,
      typingTimeout: 0,
      confirmDialogOpen: false,
      submit: false,
      employeeSelected: '',
    }
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  _handleChange = (name, value) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    const self = this

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout)
    }

    self.setState({
      search: stateValue.data.value,
      typing: false,
      typingTimeout: setTimeout(() => {
        this.props.filterRemindersList(self.state.search)
      }, 2000),
    })

    this.setState({ search: stateValue.data.value })
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }
  _openConfirmDialog = (empId) => {
    this.setState({ confirmDialogOpen: true })
    this.setState({ employeeSelected: empId })
  }

  _closeConfirmDialog = () => {
    this.setState({ confirmDialogOpen: false })
  }

  _saveConfirmDialog = () => {
    this.setState({
      confirmDialogOpen: false,
      submit: true,
    })
    this.props.removeEmployee(this.state.employeeSelected)
  }

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.description, headerStyles)}>
          Employee Id
        </th>
        <th className={(styles.columns.status, headerStyles)}>Name</th>
        <th className={(styles.columns.created, headerStyles)}>Plan Status</th>
        <th className={(styles.columns.view, headerStyles)}>Plan Year</th>
        <th className={(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.partnerPlanRatingsReminderItems.length ? (
      this.props.partnerPlanRatingsReminderItems.map(reminder => (
        <tr className={styles.base} key={reminder.partnerEmpId}>
          <td className={styles.columns.description}>
            {reminder.partnerEmpId}
          </td>
          <td>{reminder.partnerName}</td>
          <td>{reminder.planStatus}</td>
          <td>{reminder.planYear}</td>
          <td>
            <Button
              onClick={() => {
                this.props.removeEmployee(reminder.partnerEmpId)
                // this._openConfirmDialog(reminder.partnerEmpId)
              }}
              type="flat"
            >
              REMOVE
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noPartnerPlans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    const confirmRemoveProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDialog },
        { label: 'REMOVE', onClick: this._saveConfirmDialog },
      ],
      title: 'Are you sure you want to remove this partner from notification email?',
      active: this.state.confirmDialogOpen,
      onClose: this._closeConfirmDialog,
    }
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <div className={styles.searchinput}>
          <TextInput
            showSearchIcon
            handleChange={this._handleChange}
            label="Search"
            name="Search"
            onBlur={this._handleValidation}
            onFocus={this._handleFocus}
            text={this.state.search}
          />
        </div>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
        <Dialog {...confirmRemoveProps} />
      </div>
    )
  }
}

export default PartnerPlanReminderNotificationList



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/PartnerPlan/PartnerPlanReminderNotificationList.js